import { Link } from 'react-router-dom';
import { ShoppingBag, ArrowRight } from 'lucide-react';

export const EmotionalCTA = () => {
  return (
    <section className="py-16 md:py-20 bg-[#4A5D4F] relative overflow-hidden" data-testid="emotional-cta">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 right-10 w-40 h-40 border border-[#D4C5A9] rounded-full" />
        <div className="absolute bottom-10 left-20 w-60 h-60 border border-[#D4C5A9] rounded-full" />
      </div>
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative">
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">
          Überrasche deine Liebsten mit einem Geschenk, das von Herzen kommt
        </h2>
        <p className="text-lg text-white/70 mb-10 max-w-2xl mx-auto">
          Jedes Geschenk wird liebevoll ausgewählt und verpackt.
          Bestelle jetzt und lass die Freude rechtzeitig ankommen.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/geschenke"
            className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-4 rounded-full font-medium text-lg hover:bg-[#D4C5A9] transition-all hover:shadow-xl"
            data-testid="emotional-cta-button"
          >
            <ShoppingBag className="w-5 h-5" />
            Jetzt Geschenk entdecken
          </Link>
          <Link
            to="/ramadan"
            className="inline-flex items-center gap-2 border-2 border-white/30 text-white px-8 py-4 rounded-full font-medium hover:bg-white/10 transition-all"
          >
            Ramadan Ideen <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
